<script>
import MascotAca from "./components/MascotAcademic.vue";
import MascotLanguage from "./components/MascotLanguage.vue";
export default {
    components: {
        MascotAca,
        MascotLanguage,
    },
    computed: {
        ag() {
            return this.$parent.ag;
        },
        wid() {
            return this.$parent.wid;
        },
        Setting() {
            return this.$parent.Settings;
        },
        Translation() {
            return this.$parent.Translation;
        },
    },
};
</script>
<template>
    <div>
        <section id="language-program">
            <div class="container-fluid">
                <div class="row row-gap-3">
                    <div class="col-md-8 order-lg-1 order-md-2 order-2">
                        <div class="section-center">
                            <MascotLanguage />
                        </div>
                    </div>
                    <div class="col-md-4 order-lg-2 order-md-1 order-1">
                        <div class="mascot">
                            <img src="https://studentpanel.net/widget/icons/girl.png" alt="*" class="img-fluid d-block mx-auto mascot-img" />
                            <button type="button" class="btn btn-role">
                                <span class="data" style="color: #ff6600">100+</span>
                                Üniversite Tercihi
                            </button>
                            <div class="mascot-overlay"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="academic-program">
            <div class="container-fluid">
                <div class="row row-gap-3">
                    <div class="col-md-4">
                        <div class="mascot">
                            <img src="https://studentpanel.net/widget/icons/girl2.webp" alt="" class="img-fluid mx-auto d-block mascot-img" />
                            <button type="button" class="btn btn-role">
                                <span class="data" style="color: #e35c59">12+</span>
                                Ülke Tercihi
                            </button>
                            <div class="mascot-overlay"></div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="section-center">
                            <MascotAca />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
